import {useState} from 'react'
import PromotionScreen from './PromotionScreen'
import {PageTitle} from 'layout/master-layout'
import {useTranslation} from 'react-i18next'

export default function ProductPromotionWrapper() {
 const {t} = useTranslation()
 const [hidePartent, setHideParent] = useState(true)
 return (
  <div className='container relative'>
   <div className='px-[72px] pt-6 pb-10 bg-white w-full min-h-full'>
    {!hidePartent && (
     <PageTitle
      breadcrumbContainerClass={
       'flex text-[#5A6066] text-sm font-normal items-center pb-6 border-[#E6EBF0]'
      }
      breadcrumbs={[
       {
        title: t('breadCrumbs.home'),
        path: '/home-page',
        isActive: false,
       },
       {
        title: t('breadCrumbs.activityManagement'),
        path: '/activity-management',
        isActive: false,
       },
       {
        title: t('breadCrumbs.productPromotion'),
        path: '',
        isActive: true,
       },
      ]}
      description='Welcome'
     >
      Product Promotion
     </PageTitle>
    )}
    <PromotionScreen
     hidePartent={hidePartent}
     setHideParent={setHideParent}
    />
   </div>
  </div>
 )
}
